export const ON_API_ERROR = 'ON_API_ERROR';
export const ON_APPLICATION_TEMPLATE_FETCH_REQUEST = 'ON_APPLICATION_TEMPLATE_FETCH_REQUEST';
export const ON_APPLICATION_TEMPLATE_FETCH_SUCCESS = 'ON_APPLICATION_TEMPLATE_FETCH_SUCCESS';
export const ON_APP_DETAILS_FETCH_REQUEST = 'ON_APP_DETAILS_FETCH_REQUEST';
export const ON_APP_DETAILS_FETCH_SUCCESS = 'ON_APP_DETAILS_FETCH_SUCCESS';
export const SIGNUP_USER_REQUEST = 'SIGNUP_USER_REQUEST';
export const SIGNIN_USER_REQUEST = 'SIGNIN_USER_REQUEST';
export const USER_FORGOT_PASSWORD = 'USER_FORGOT_PASSWORD';
export const AUTH_TOKEN_SET = 'AUTH_TOKEN_SET';
export const AUTH_REDIRECT_SET = 'AUTH_REDIRECT_SET';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_LOGOUT_REQUIRED = 'AUTH_LOGOUT_REQUIRED';
export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS';

export const USER_RESET_PASSWORD_REQUEST = 'USER_RESET_PASSWORD_SUCCESS';
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS';
export const USER_PROFILE_FETCH_REQUEST = 'USER_PROFILE_FETCH_REQUEST';
export const USER_PROFILE_FETCH_SUCCESS = 'USER_PROFILE_FETCH_SUCCESS';
export const USER_PROFILE_SAVE_REQUEST = 'USER_PROFILE_SAVE_REQUEST';
export const USER_PROFILE_SAVE_SUCCESS = 'USER_PROFILE_SAVE_SUCCESS';
export const USER_TREASURES_FETCH_REQUEST = 'USER_TREASURES_FETCH_REQUEST';
export const USER_TREASURES_FETCH_SUCCESS = 'USER_TREASURES_FETCH_SUCCESS';
export const USER_DEFINITIONS_FETCH_REQUEST = 'USER_DEFINITIONS_FETCH_REQUEST';
export const USER_DEFINITIONS_FETCH_SUCCESS = 'USER_DEFINITIONS_FETCH_SUCCESS';
export const USER_DEFINITIONS_SAVE_REQUEST = 'USER_DEFINITIONS_SAVE_REQUEST';
export const USER_DEFINITIONS_SAVE_SUCESS = 'USER_DEFINITIONS_SAVE_SUCESS';

export const USER_UPDATE_PASSWORD_SUCCESS = 'USER_UPDATE_PASSWORD_SUCCESS';
export const USER_UPDATE_COINS = 'USER_UPDATE_COINS';

export const PLAYER_JOIN_GAME = 'PLAYER_JOIN_GAME';
export const PLAYER_JOINED_GAME = 'PLAYER_JOINED_GAME';
export const PLAYER_KICKED = 'PLAYER_KICKED';
export const PLAYER_READY_FOR_GAME = 'PLAYER_READY_FOR_GAME';
export const PLAYER_READY_REQUEST = 'PLAYER_READY_REQUEST';
export const PLAYER_LEAVE_GAME = 'PLAYER_LEAVE_GAME';
export const PLAYER_LEFT_GAME = 'PLAYER_LEFT_GAME';
export const PLAYER_REJOIN_GAME = 'PLAYER_REJOIN_GAME';

export const PLAYER_REMOTE_VIDEO_MUTED = 'PLAYER_REMOTE_VIDEO_MUTED';
export const PLAYER_REMOTE_VIDEO_UNMUTED = 'PLAYER_REMOTE_VIDEO_UNMUTED';

export const GAME_LIST_REQUEST = 'GAME_LIST_REQUEST';
export const GAME_LIST_SUCCESS = 'GAME_LIST_SUCCESS';
export const GAME_ABLY_UPDATED = 'GAME_ABLY_UPDATED';
export const GAME_ABLY_CREATED = 'GAME_ABLY_CREATED';
export const GAME_MOBILE_BRANCHIO_LINK_REQUEST = 'GAME_MOBILE_BRANCHIO_LINK_REQUEST';
export const GAME_MOBILE_BRANCHIO_LINK_SUCCESS = 'GAME_MOBILE_BRANCHIO_LINK_SUCCESS';

export const GAME_LANDING_SHOWED = 'GAME_LANDING_SHOWED';

export const TEAM_GETS_POINTS = 'TEAM_GETS_POINTS';
export const PLAYER_GETS_POINTS = 'PLAYER_GETS_POINTS';

export const PLAYER_CONFIRM_MEDIA = 'PLAYER_CONFIRM_MEDIA';
export const PLAYER_ANSWER_REQUEST = 'PLAYER_ANSWER_REQUEST';
export const PLAYER_ANSWER_SUCCESS = 'PLAYER_ANSWER_SUCCESS';

export const PLAYER_SEND_GIFT_REQUEST = 'PLAYER_SEND_GIFT_REQUEST';
export const PLAYER_SEND_GIFT_SUCCESS = 'PLAYER_SEND_GIFT_SUCCESS';
export const PLAYER_KICK_REQUEST = 'PLAYER_KICK_REQUEST';
export const PLAYER_KICK_SUCCESS = 'PLAYER_KICK_SUCCESS';
export const PLAYER_KICK_FAILURE = 'PLAYER_KICK_FAILURE';
export const ABLY_PLAYER_KICK_INIT = 'ABLY_PLAYER_KICK_INIT';
export const PLAYER_KICK_CANCEL = 'PLAYER_KICK_CANCEL';
export const PLAYER_LEAVE_AS_KICKED = 'PLAYER_LEAVE_AS_KICKED';
export const ABLY_PLAYER_KICK_VOTED = 'ABLY_PLAYER_KICK_VOTED';
export const ABLY_PLAYER_KICKED = 'ABLY_PLAYER_KICKED';
export const PLAYER_NOTICE_CLEARED = 'PLAYER_NOTICE_CLEARED';
export const PLAYER_COINS_CHANGED = 'PLAYER_COINS_CHANGED';

export const ON_MODAL_OPEN = 'ON_MODAL_OPEN';
export const ON_MODAL_CLOSE = 'ON_MODAL_CLOSE';

export const ABLY_PLAYER_READY = 'ABLY_PLAYER_READY';
export const ABLY_PLAYER_JOINED_GAME = 'ABLY_PLAYER_JOINED_GAME';
export const ABLY_PLAYER_LEFT_GAME = 'ABLY_PLAYER_LEFT_GAME';
export const ABLY_PLAYER_ANSWER_HAS_CHECKED = 'ABLY_PLAYER_ANSWER_HAS_CHECKED';
export const ABLY_PLAYER_ANSWER_HAS_SELECTED = 'ABLY_PLAYER_ANSWER_HAS_SELECTED';
export const ABLY_PLAYER_GIFT_HAS_RECEIVED = 'ABLY_PLAYER_GIFT_HAS_RECEIVED';

export const ABLY_GAME_HAS_STARTED = 'ABLY_GAME_HAS_STARTED';
export const ABLY_GAME_QUESTION_NEXT = 'ABLY_GAME_QUESTION_NEXT';
export const ABLY_GAME_HAS_FINISHED = 'ABLY_GAME_HAS_FINISHED';

export const ABLY_GAME_ROUND_FINISHED = 'ABLY_GAME_ROUND_FINISHED';
export const ABLY_GAME_ROUND_STARTED = 'ABLY_GAME_ROUND_STARTED';

export const ABLY_GAME_INTERSTITIAL_STARTED = 'ABLY_GAME_INTERSTITIAL_STARTED';
export const ABLY_GAME_INTERSTITIAL_FINISHED = 'ABLY_GAME_INTERSTITIAL_FINISHED';

export const ABLY_GAME_RESPONDENT_HAS_BEEN_CHANGED = 'ABLY_GAME_RESPONDENT_HAS_BEEN_CHANGED';

export const ABLY_GAME_ADMIN_HAS_CHANGED = 'ABLY_GAME_ADMIN_HAS_CHANGED';

export const GAME_TEAM_DEFINITION_REQUEST = 'GAME_TEAM_DEFINITION_REQUEST';
export const GAME_TEAM_DEFINITION_SUCCESS = 'GAME_TEAM_DEFINITION_SUCCESS';

export const API_LEADERBOARD_FETCH = 'API_LEADERBOARD_FETCH';
export const API_LEADERBOARD_SUCCESS = 'API_LEADERBOARD_SUCCESS';
export const API_LEADERBOARD_ERROR = 'API_LEADERBOARD_ERROR';

export const API_TREASURE_FETCH = 'API_TREASURE_FETCH';
export const API_TREASURE_FETCH_SUCCESS = 'API_TREASURE_FETCH_SUCCESS';
export const API_TREASURE_REDEEM_REQUEST = 'API_TREASURE_REDEEM_REQUEST';
export const API_TREASURE_REDEEM_SUCCESS = 'API_TREASURE_REDEEM_SUCCESS';
export const API_TREASURE_REDEEM_CLEAN = 'API_TREASURE_REDEEM_CLEAN';
export const PLAYER_ENTERED_GAME_BY_DIRECT_LINK = 'PLAYER_ENTERED_GAME_BY_DIRECT_LINK';

export const API_REDEMPTION_FETCH = 'API_REDEMPTION_FETCH';
export const API_REDEMPTION_FETCH_SUCCESS = 'API_REDEMPTION_FETCH_SUCCESS';
export const API_REDEMPTION_FETCH_ERROR = 'API_REDEMPTION_FETCH_ERROR';
export const API_REDEMPTION_APPROVE_REQUEST = 'API_REDEMPTION_APPROVE_REQUEST';
export const API_REDEMPTION_APPROVE_SUCCESS = 'API_REDEMPTION_APPROVE_SUCCESS';
export const API_REDEMPTION_REJECT_REQUEST = 'API_REDEMPTION_REJECT_REQUEST';
export const API_REDEMPTION_REJECT_SUCCESS = 'API_REDEMPTION_REJECT_SUCCESS';

export const API_PAYMENT_PACKS_FETCH = 'API_PAYMENT_PACK_FETCH';
export const API_PAYMENT_PACKS_FETCH_SUCCESS = 'API_PAYMENT_PACK_SUCCESS';
export const API_PAYMENT_PACKS_FETCH_ERROR = 'API_PAYMENT_PACK_ERROR';

export const ABLY_USER_IS_ONLINE = 'ABLY_USER_IS_ONLINE';
export const ABLY_USER_IS_OFFLINE = 'ABLY_USER_IS_OFFLINE';

export const CHAT_PANEL_TOGGLE = 'CHAT_PANEL_TOGGLE';
export const CHAT_PANEL_CLOSE = 'CHAT_PANEL_CLOSE';
export const TREASURE_PANEL_TOGGLE = 'TREASURE_PANEL_TOGGLE';
export const TREASURE_PANEL_CLOSE = 'TREASURE_PANEL_CLOSE';
export const LEADERBOARD_PANEL_TOGGLE = 'LEADERBOARD_PANEL_TOGGLE';
export const LEADERBOARD_PANEL_CLOSE = 'LEADERBOARD_PANEL_CLOSE';
export const SIDEBAR_STATUS = 'SIDEBAR_STATUS';
export const SET_MEDIA_SETTINGS = 'SET_MEDIA_SETTINGS';
export const HELP_STATUS = 'HELP_STATUS';
